/**
 * Renders a plain-text string with:
 *  - Blank lines → paragraph breaks
 *  - Lines starting with •, -, or * → <ul> bullet list
 */
export function RichText({ text, className = "" }) {
  if (!text) return null;

  // Split into paragraphs on blank lines
  const paragraphs = text.split(/\n{2,}/);

  return (
    <div className={className}>
      {paragraphs.map((para, pi) => {
        const lines = para.split("\n").map((l) => l.trim()).filter(Boolean);

        // Detect bullet block: every non-empty line starts with •, -, or *
        const isList = lines.length > 0 && lines.every((l) => /^[•\-*]\s+/.test(l));

        if (isList) {
          return (
            <ul key={pi} className="list-disc list-outside pl-5 space-y-1 mt-2">
              {lines.map((l, li) => (
                <li key={li}>{l.replace(/^[•\-*]\s+/, "")}</li>
              ))}
            </ul>
          );
        }

        // Mixed paragraph: render inline with <br /> for single newlines
        return (
          <p key={pi} className={pi > 0 ? "mt-4" : ""}>
            {lines.map((l, li) => (
              <span key={li}>
                {li > 0 && <br />}
                {l}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}
